import styled from '@emotion/styled';

import { ColumnHeaderTemplate, CustomerButtonWrapper, TableCellTemplate, TableHeaderRowTemplate, TablePropsType, TableRowTemplate, TableWrapperTemplate } from 'src/components/FraudAndCompliance/FraudAndCompliancesTab/FraudAndCompliances/components/CommonTable.styles';



export const TableWrapper = styled(TableWrapperTemplate, { label: 'TableWrapper' })`

    table-layout: fixed;

`;



export const TableHeaderRow = styled(TableHeaderRowTemplate, { label: 'TableHeaderRow' })``;



export const TableHeader = styled(ColumnHeaderTemplate, { label: 'TableHeader' })``;



export const TableRow = styled(TableRowTemplate, { label: 'TableRow' })<TablePropsType>``;





export const TableCell = styled(TableCellTemplate, { label: 'TableCell' })`

    span {

        display: block;

    }

`;



export const StatusOnlineIndicator = styled('div', { label: 'StatusOnlineIndicator' })`

    background: #ccc;

    border-radius: 2px;

    bottom: 4px;

    left: 4px;

    position: absolute;

    top: 4px;

    width: 8px;

`;





export const CustomerButtonWrapperStatus = styled(CustomerButtonWrapper, { label: 'CustomerButtonWrapperStatus' })`

    padding-left: 16px;

`;

